<template>
  <div class="tools-content-box">
      <div class="box-title">
        <slot name='title' ></slot>
      </div>
      <div class="tools-category-content">
        <div
          class="tools-category"
          v-for="tool in this.list"
          :key="tool.originName"
          v-tooltip="tool.name"
        >
          <div class="box-tool " :style="inlineBgImage(tool.url)"></div>
          <span :title="tool.name" >{{ tool.originName }}</span>
        </div>
      </div>
    </div>
</template>

<script>
import utils from "../../mixins/utils";

export default {
 name: 'ToolBoxCategory',
 mixins: [utils],
 props: {
    list: {
        type: Array,
        require: true
    }
 },
 data(){
    return {

    }
 },
 methods: {

 }
}
</script>

<style>
.tools-content-box {
  background: #f8f8f8;
  padding: 1em;
  border-radius: 10px;
  width: 80%;
}

.tools-category-content {
  display: grid;
  /* grid-template-columns: repeat(4, 1fr); */
  grid-template-columns: repeat(3, 1fr);
  font-size: 12px;
  gap: 10px;
  align-content: start;
  justify-content: center;
}


.tools-category {
  min-width: 80px;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.box-title {
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 1em;
  color: #424242;
  font-weight: bold;
  font-size: 18px;
}

.box-tool {
  width: 40px;
  height: 40px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 5px;
}
</style>